/**
 * Which `emails.status` values mean "Yaruta is still reading this email"
 * (YAR-477). One definition, shared by the Review card, the feed's in-flight
 * poll and the status toast's run model, so the three cannot disagree.
 *
 * HELD is included on purpose: a hold is Yaruta waiting out a provider outage
 * and retrying on its own (YAR-212). To the parent that is still reading — it
 * never needs them to act — and the server's 5-minute reading timeout skips
 * HELD for the same reason (see `sweep_reading_timeouts`).
 */
export const READING_STATUSES = ['RECEIVED', 'PROCESSING', 'HELD'] as const;

export type ReadingStatus = (typeof READING_STATUSES)[number];

export function isReadingStatus(
  status: string | null | undefined,
): status is ReadingStatus {
  return (READING_STATUSES as readonly string[]).includes(status ?? '');
}
